import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { VideoPlayer } from '@/components/VideoPlayer';
import iphoneBezel from '@/assets/bezel.png';
import { useVideoControl } from '@/hooks/useVideoControl';

const FinishPage = () => {
  const { t } = useTranslation();
  const { setCurRef, play } = useVideoControl();
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { language } = i18n;

  const interviewLink = location.state?.interviewLink as string | undefined;

  // If no interview link, redirect back to home
  if (!interviewLink) {
    navigate('/', { replace: true });
    return null;
  }

  const finalVideoSrc =
    language === 'en' ? '/final_video_en.mp4' : '/final_video_es.mp4';

  return (
    <div className="min-h-screen flex flex-col justify-self-center items-center w-full bg-[url(/background.png)]">
      <div className="min-h-screen flex flex-col items-center justify-between gap-4 py-16 px-6 max-w-md w-full text-center">
        <h1 className="text-[#1E3A8A] text-xl font-bold">
          {t('finish.title')}
        </h1>
        <p className="text-base font-bold">{t('finish.message.line1')}</p>
        <p className="text-base font-bold">{t('finish.message.line2')}</p>

        <div className="w-[270px] h-[465px] p-[10px] relative">
          <img
            src={iphoneBezel}
            alt=""
            className="absolute w-full h-full top-0 left-0 z-10"
            onClick={play}
          />
          <VideoPlayer
            width="250px"
            height="445px"
            style={{ borderRadius: '36px' }}
            src={finalVideoSrc}
            onSetCurRef={setCurRef}
            autoPlay
          />
        </div>

        <p className="text-[#1E3A8A] text-xl font-bold">{t('finish.seeYou')}</p>
      </div>
    </div>
  );
};

export default FinishPage;
